import { useTranslation } from 'react-i18next'
import React from 'react'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../../../packages/kiti/components/helpers/Line'
import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import MarkdownEditor from '../../../../../../packages/kiti-editor/components/markdown/MarkdownEditor'
import GalleryInput from '../../../../../../components/form/GalleryInput'
import FieldValuesFormSection from '../../../../../../containers/fieldValues/form/FieldValuesFormSection'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'

const FieldsSection = () => {
  const { t } = useTranslation('triggers')
  const { form } = useFormState()

  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('fieldsSection.additionalFields')}
      </Title>
      <Line />
      <Separator weight={4} />

      <FieldValuesFormSection //
        origin="service_orders"
        path={['payload', 'field_values']}
        hideTitle
        isPropSnakeCase
        interpolations
      />

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%">
          <FormItem
            label={t('triggers:fields.description')}
            path={['payload', `description`]}
            Input={MarkdownEditor}
            interpolations={interpolations}
          />
        </Col>

        <Col width="100%">
          <FormItem path={['payload', 'documents']} Input={GalleryInput} buttonLabel={t('fieldsSection.addFile')} />
        </Col>
      </Grid>
    </>
  )
}

export default FieldsSection
